export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const APPLE_SERVICE_ID = process.env.REACT_APP_APPLE_SERVICE_ID;

export const LANG_OPTIONS = [
  { code: "en", name: "English" },
  { code: "es", name: "Spanish" },
  { code: "fr", name: "French" },
  { code: "de", name: "German" },
  { code: "pt", name: "Portuguese" },
  { code: "it", name: "Italian" },
  { code: "ja", name: "Japanese" },
  { code: "ko", name: "Korean" },
  { code: "zh", name: "Chinese" },
  { code: "hi", name: "Hindi" },
  { code: "ar", name: "Arabic" },
  { code: "ru", name: "Russian" },
];

export const VIBES_POOL = ["Coffee", "Vinyl", "Skater", "Foodie", "Bookworm", "Gamer", "Hiker", "Artist", "Runner", "Night Owl"];
export const EMOJIS = ["🌙", "✨", "🔥", "🌊", "🌸", "🪐", "🌈", "💫", "🍓", "🌶️"];

export const COMMUNITY_RULES = [
  "I confirm I am 18 years of age or older.",
  "I will not impersonate another person on my video or profile.",
  "I will treat every user with respect — no harassment or hate.",
  "I will not share illegal, sexual, or violent content.",
  "I will not use this app for spam, scams, or commercial solicitation.",
  "I understand my video may be reviewed for safety verification.",
  "I consent to my face being briefly analysed by AI to verify my intro video, as described in the Privacy Policy.",
  "I accept Nice2Meechu's full Terms of Service & Privacy Policy.",
];
